/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Misha Kokoulin
 * @version 1.0.1
 * @since 1.0.0
 */

import { call } from 'redux-saga/effects';

import { AccessComponentKeyEnum } from '../../constants/guard/guardConstants';
import { isButtonConditionsSaga } from './isButtonConditionsSaga';
import { isMenuEnabledConditionSaga } from './IsMenuEnabledConditionSaga';
import { IsTabMenuItemOnceConditionSaga } from './IsTabMenuItemOnceConditionSaga';

export function* checkGuardConditionsSaga(componentKey: AccessComponentKeyEnum) {

    let isAllowed: boolean;

    // check component on menu condition
    isAllowed = yield call(isMenuEnabledConditionSaga, componentKey);

    // check component on tab menu once condition
    if (isAllowed) {
        isAllowed = yield call(IsTabMenuItemOnceConditionSaga, componentKey);
    }

    if (isAllowed) {
        isAllowed = yield call(isButtonConditionsSaga, componentKey);
    }

    return isAllowed;
}
